// extracted by mini-css-extract-plugin
export var container = "IntershipCourseFor-module--container--33395";
export var item = "IntershipCourseFor-module--item--5f5bf";
export var items = "IntershipCourseFor-module--items--d354e";
export var lmsScrollbar = "IntershipCourseFor-module--lms-scrollbar--1a14d";
export var wrapper = "IntershipCourseFor-module--wrapper--fcaf1";